import { useEffect, useState } from 'react';
import { getFundsQuotesLastDate } from '../../api/fundsQuotesApi';

interface UseFundsQuotesLastDateApiResult {
  data?: string;
  isLoading: boolean;
}

export function useFundsQuotesLastDateApi(
  fundId: number,
  unitCategory: string,
  enabled: boolean,
): UseFundsQuotesLastDateApiResult {
  const [data, setData] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled) return;
    let subscribed = true;
    setIsLoading(true);
    getFundsQuotesLastDate(fundId, unitCategory).then(response => {
      if (subscribed) {
        setData(response);
        setIsLoading(false);
      }
    });
    return () => { subscribed = false; };
  }, [fundId, unitCategory, enabled]);

  return { data, isLoading };
}
